import { Card, CardBody, Input, Row, Col } from "reactstrap";
import React, { useMemo, useState } from "react";
import { cloneDeep } from "lodash";
import { DynamicForm } from "../../../custom/components/DynamicForm";
import { formModes, vesselDataStructureState } from "../vessels/state";
import { useRecoilValue } from "recoil";
import { Loader } from "../../../custom/components/Loader";
import { validateRegistrationRequest } from "../../../api/controller/VesselController";
import { handleResponse } from "../../../custom/helpers/HandleResponse";

const AddNewVessel = ({ setCurrentScreen, refreshMyVessels, setResubmitVessel }) => {
    const [formSubmitDisabled, setFormSubmitDisabled] = useState(true);
    const [step, setStep] = useState("reg");
    const [regNumber, setRegNumber] = useState("");
    const [info, setInfo] = useState({});
    const [loading, setLoading] = useState(false);
    const dataStructure = useRecoilValue(vesselDataStructureState);

    // Clone the shared data structure and lock + prefill the Registration Number
    // field for the create form (create mode seeds values from each field's
    // create-config `default`; `validations: 'readonly'` keeps it submitted).
    const formDataStructure = useMemo(() => {
        const clone = cloneDeep(dataStructure);
        const regCol = clone.find((c) => c.label === "Registration Number");
        if (regCol && Array.isArray(regCol.create) && regCol.create[0] && typeof regCol.create[0] === "object") {
            regCol.create[0] = { ...regCol.create[0], default: regNumber.trim(), validations: "readonly" };
        }
        return clone;
    }, [dataStructure, regNumber]);

    const onContinue = async () => {
        if (!regNumber.trim()) return;
        setLoading(true);
        const res = await validateRegistrationRequest({ RegistrationNumber: regNumber.trim() });
        setLoading(false);
        if (!res || res.Status === "error") {
            handleResponse(res);
            return;
        }
        const data = res.Data || {};
        if (data.outcome === "ALLOW") {
            setStep("form");
            setFormSubmitDisabled(false);
        } else if (data.outcome === "RESUBMIT") {
            if (setResubmitVessel) setResubmitVessel(data.vessel);
            setCurrentScreen("resubmitVessel");
        } else {
            setInfo(data);
            setStep("duplicate");
        }
    };

    return (
        <React.Fragment>
            <Loader loading={loading || (step === "form" && formSubmitDisabled)} transparent />
            <button
                className="btn btn-primary fs-6 py-1"
                onClick={() => setCurrentScreen("myVessels")}
            >
                <span className="mdi mdi-chevron-left align-middle fs-3 me-2"></span>
                <span className="fs-6">Back</span>
            </button>
            <Card className="mt-4">
                <CardBody>
                    <h4>Add New Vessel</h4>

                    {step === "reg" && (
                        <Row className="mt-3">
                            <Col xs={12} md={6}>
                                <label>Registration Number</label>
                                <Input
                                    value={regNumber}
                                    onChange={(e) => setRegNumber(e.target.value)}
                                    placeholder="Enter registration number"
                                />
                            </Col>
                            <Col xs={12} className="mt-3">
                                <button className="btn btn-primary" disabled={loading} onClick={onContinue}>
                                    Continue
                                </button>
                            </Col>
                        </Row>
                    )}

                    {step === "duplicate" && (
                        <div className="mt-3">
                            <p>{info.message}</p>
                            {info.outcome === "DUPLICATE_APPROVED" && !info.ownedByMe && (
                                <>
                                    <p className="mb-1">
                                        <b>Vessel:</b> {info.vessel?.name}
                                        {info.vessel?.approved_at
                                            ? ` (registered ${new Date(info.vessel.approved_at).toLocaleDateString()})`
                                            : ""}
                                    </p>
                                    <button
                                        className="btn btn-outline-primary"
                                        onClick={() => setCurrentScreen("requestVesselAccess")}
                                    >
                                        Request access with owner's code
                                    </button>
                                </>
                            )}
                        </div>
                    )}

                    {step === "form" && (
                        <DynamicForm
                            config={{
                                visible: true,
                                type: "Create",
                                typeKey: 0,
                                modal: false,
                                customCloseFn: () => setCurrentScreen("myVessels"),
                                customPushFn: () => {
                                    if (typeof refreshMyVessels === "function") {
                                        refreshMyVessels();
                                    }
                                },
                            }}
                            ds={formDataStructure}
                            submitModes={formModes}
                            setFormSubmitDisabled={setFormSubmitDisabled}
                        />
                    )}
                </CardBody>
            </Card>
        </React.Fragment>
    );
};
export default AddNewVessel;
